import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PharmacyImportDto } from 'webcommon/shared';
import { PharmacyRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class ManagePharmacyService {

  constructor(
    private pharmacyRepository: PharmacyRepository,
  ) {
  }

  public updatePharmacyItems(id: string, uId: string, pharmacyImports: PharmacyImportDto): Observable<number> {
    return this.pharmacyRepository.updatePharmacyItems(id, uId, pharmacyImports);
  }
}
